<script lang="ts">
import GenericButton from "@/Components/Generics/GenericButton.vue";
import Plane from "@/Components/Generics/Plane.vue";
import MainPage from "@/Components/MainPage.vue";
import Authenticated from "@/Layouts/Authenticated.vue";
import { defineComponent } from "vue";

export default defineComponent({
    name: "CompanyDashboardVue",
    components: {
        MainPage,
        Plane,
        GenericButton,
    },
    layout: Authenticated,
    methods: {
        clickCompanies(): void {
            this.$inertia.visit(route("companies.index"));
        },
    },
});
</script>

<template>
    <MainPage :title="$trans('dashboard.title')" :gap="true">
        <div id="startOfSearchCompany" class="page-section flex flex--width flex--v flex--valign-c flex--gap-50">
            <div class="flex flex--v flex--valign-c flex--gap-50">
                <!-- TITLE -->
                <div class="flex flex--v flex--valign-c flex--gap-10">
                    <span class="text text--primary-gradient text--bold text--size-30 text--center">
                        {{ $trans("dashboard.greetings-title") }}
                    </span>
                    <span class="text text--secondary-gradient text--medium text--size-24 text--less-gap text--center">
                        {{ $trans("dashboard.greetings-subtitle") }}
                    </span>
                </div>

                <!-- INFO -->
                <div class="flex flex--v flex--valign-c flex--gap-30">
                    <div class="flex flex--v flex--valign-c flex--gap-15">
                        <span class="text text--accent-gray-b text--medium text--size-20 text--height-27 text--center" v-html="$trans('dashboard.greetings-1')"></span>
                        <span class="text text--accent-gray-b text--medium text--size-20 text--height-27 text--center" v-html="$trans('dashboard.greetings-2')"></span>
                    </div>

                    <Plane :rounded="true">
                        <div class="flex flex--v flex--width flex--valign-s flex--gap-15">
                            <span class="text text--primary-b text--bold text--size-24 text--height-27 text--left" v-html="$trans('dashboard.greetings-3')"></span>
                            <span class="text text--accent-gray-b text--medium text--size-20 text--height-27 text--left" v-html="$trans('dashboard.greetings-4')"></span>
                            <span class="text text--accent-gray-b text--medium text--size-20 text--height-27 text--left" v-html="$trans('dashboard.greetings-5')"></span>
                        </div>
                    </Plane>

                    <Plane :rounded="true">
                        <div class="flex flex--v flex--width flex--valign-s flex--gap-15">
                            <span class="text text--primary-b text--bold text--size-24 text--height-27 text--left" v-html="$trans('dashboard.greetings-6')"></span>
                            <span class="text text--accent-gray-b text--medium text--size-20 text--height-27 text--left" v-html="$trans('dashboard.greetings-7')"></span>
                            <span class="text indent text--accent-gray-b text--medium text--size-20 text--height-27 text--left" v-html="$trans('dashboard.greetings-8')"></span>
                            <span class="text indent text--accent-gray-b text--medium text--size-20 text--height-27 text--left" v-html="$trans('dashboard.greetings-9')"></span>
                            <span class="text indent text--accent-gray-b text--medium text--size-20 text--height-27 text--left" v-html="$trans('dashboard.greetings-10')"></span>
                            <span class="text text--accent-gray-b text--medium text--size-20 text--height-27 text--left" v-html="$trans('dashboard.greetings-11')"></span>
                            <span class="text indent text--accent-gray-b text--medium text--size-20 text--height-27 text--left" v-html="$trans('dashboard.greetings-12')"></span>
                        </div>
                    </Plane>

                    <div class="flex flex--v flex--valign-c flex--gap-15">
                        <span class="text text--accent-gray-b text--medium text--size-20 text--height-27 text--center" v-html="$trans('dashboard.greetings-13')"></span>
                        <span class="text text--accent-gray-b text--medium text--size-20 text--height-27 text--center" v-html="$trans('dashboard.greetings-14')"></span>
                    </div>
                </div>

                <!-- CTA -->
                <GenericButton :title="$trans('navigation.nav_acp_companies')" @click="clickCompanies" />
            </div>
        </div>
    </MainPage>
</template>

<style lang="scss" scoped>
.indent {
    padding-left: rem(30);
}
@include media-breakpoint-down(xl) {
    .page-section {
        gap: rem(45);
    }
}
@include media-breakpoint-down(lg) {
    .page-section {
        gap: rem(45);
    }
}
@include media-breakpoint-down(md) {
    .page-section {
        gap: rem(35);
    }
}
@include media-breakpoint-down(sm) {
    .page-section {
        gap: rem(25);
    }
}

// old

// div {
//     padding: 0px 150px 0px 150px;
// }

// .indent {
//     text-indent: 2em;
//     display: block;
// }

.greetings::before {
    @include bevelled_edge_18($background-blue);
    z-index: -1;
}

.greetings {
    margin-top: 20px;
    padding: 20px 0 20px 0;
    position: relative;
    overflow: hidden;
    z-index: 1;
}

.title {
    padding-left: 60px;
}

div.text {
    background-color: $black30;
    line-height: 1.3;
    padding: 20px 60px 20px 60px;
}

@include media-breakpoint-down(lg) {
    div.wrapper {
        padding: 0px 50px 0px 50px;
    }
}
@include media-breakpoint-down(md) {
    div.wrapper {
        padding: 0px 20px 0px 20px;

        .title {
            padding-left: 20px;
        }

        .text {
            padding: 20px 20px 20px 20px;
        }
    }
}
</style>
